import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MenuOutlined } from "@ant-design/icons";
import ProfileDropdown from "../../../components/ProfileDropdown";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { logout, setAccess } from "../../../store/authSlice";
import { denyAccess } from "../../../api/access";

/** TopBar-ът на „Конфигурация на маси" — същият като на страниците в Конфигурация. */
const TablesConfigTopBar = ({ isNarrow, onOpenMobileMenu }: { isNarrow: boolean; onOpenMobileMenu: () => void }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const access = useAppSelector((state) => state.auth.access);
  const names = useAppSelector((state) => state.auth.names);
  const username = useAppSelector((state) => state.auth.username);

  const handleLogout = async () => {
    if (access) {
      try {
        await denyAccess();
      } catch (error) {
        console.error("Deny access error:", error);
      }
      dispatch(setAccess(false));
      navigate("/", { replace: true });
    } else {
      await dispatch(logout());
      navigate("/login", { replace: true });
    }
  };

  return (
    <div
      className={`flex min-h-12 shrink-0 items-center justify-between gap-2.5 border-b border-shade-2 px-4 py-2.5 sm:min-h-[60px] sm:px-7 sm:py-[11px] ${
        access
          ? "bg-[radial-gradient(ellipse_40%_120%_at_100%_50%,var(--color-brand-tint)_0%,transparent_70%),var(--color-surface)]"
          : "bg-surface"
      }`}
    >
      <div className="flex min-w-0 flex-1 items-center gap-2.5">
        {isNarrow && (
          <button
            type="button"
            onClick={onOpenMobileMenu}
            aria-label="Open menu"
            className="flex h-[34px] w-[34px] shrink-0 cursor-pointer items-center justify-center rounded-lg border-none bg-transparent text-[18px] text-ink"
          >
            <MenuOutlined />
          </button>
        )}
        <div className="min-w-0">
          <h1 className="m-0 truncate text-[18px] font-bold leading-[1.2] tracking-[-0.5px] text-ink sm:text-[22px]">
            {t("tablesConfig.title")}
          </h1>
          {!isNarrow && (
            <div className="mt-1 truncate text-[12px] font-medium text-muted">{t("tablesConfig.subtitle")}</div>
          )}
        </div>
      </div>
      <ProfileDropdown
        displayName={names || username || ""}
        username={username ?? ""}
        access={access}
        isNarrow={isNarrow}
        onLogout={handleLogout}
      />
    </div>
  );
};

export default TablesConfigTopBar;
